import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from '@mui/material';

interface TablePlaceholderProps {
  /** The number of rows that the placeholder component should render. Defaults to 5 */
  rowCount?: number;

  /** The height of each row. Defaults to 10px */
  rowHeight?: number;

  /** The vertical gap between each row. Defaults to 5px */
  rowGap?: number;

  /** Additional styles to be applied to the SVG element */
  style?: React.CSSProperties;
}

const TablePlaceholderV3: React.FC<TablePlaceholderProps> = ({
  rowCount = 5,
  rowHeight = 10,
  rowGap = 5,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <ContentLoader
      height={rowCount * rowHeight + (rowCount - 1) * rowGap}
      primaryColor={theme.palette.tokens?.background.neutral.canvas.base}
      secondaryColor={theme.palette.tokens?.background.brand.dark[3]}
      {...rest}
    >
      {[...Array(rowCount)].map((__, index) => (
        <rect
          key={index}
          x="0"
          y={index * (rowHeight + rowGap)}
          rx="1"
          ry="1"
          width="100%"
          height={rowHeight}
        />
      ))}
    </ContentLoader>
  );
};

export default TablePlaceholderV3;
